import React, { FC, useEffect, useState } from "react";
import { Row, Col } from "antd";
import DispatchPanel from "./DispatchPanel/index";
import MapPanel from "../../../containers/Dashboard/MapPanel/index";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import Autocomplete from "react-google-autocomplete";
import Geocode from "react-geocode";

Geocode.setApiKey("AIzaSyDNIyoSDV1wnJVW8wdHkiNG-eZ2bMcq0iY");
Geocode.setLanguage("en");
Geocode.setRegion("us");

const CalendarDashboard: FC<{ socket: ISocket }> = ({ socket }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [callingPageId, setCallingPageId] = useState<string | undefined>(
    undefined
  );
  const [videoPlayerOpen, setVideoPlayerOpen] = useState<boolean>(false);
  const [isCallNotificationDisplayed, setCallNotificaitonDisplayed] =
    useState<boolean>(false);
  const [screens, setScreens] = useState<any>({
    form: true,
    map: false,
  });

  const params: any = {
    screens,
    setScreens,
  };

  const fixedColSize = 24;

  return (
    <Row className="main-layout">
      {screens.form && (
        <Col
          md={screens.map ? 12: fixedColSize}
          xs={24}
          className={screens.active === "form" ? "active-screen" : ""}
        >
          {screens.form && <DispatchPanel socket={socket} params={params} />}
        </Col>
      )}
      {screens.map && (
        <Col
          md={12}
          xs={24}
          className={screens.active === "map" ? "active-screen" : ""}
        >
          <MapPanel socket={socket} params={params} />
        </Col>
      )}
      <Autocomplete
        apiKey="AIzaSyDNIyoSDV1wnJVW8wdHkiNG-eZ2bMcq0iY"
        style={{ display: "none" }}
        options={{
          types: ["(regions)"],
          componentRestrictions: { country: ["us", "ca", "uk"] },
        }}
      />
    </Row>
  );
};
export default CalendarDashboard;
